(function($) {

    //* Make sure JS is enabled
    document.documentElement.className = "js";


    $(document).ready(() => {
        $('.range-slider').jRange({
            from: 3000,
            to: 100000,
            step: 1000,
            scale: [3000, 100000],
            format: '%s',
            width: '500',
            showLabels: true,
            isRange: true,
            snap: true,
        });
        $('.range-slider').jRange('setValue', '10000,30000');
    });
})(jQuery);
